import React from "react";
import styled from "styled-components";
import OurServiceImg1 from "../../../assets/ourserviceimg1.svg";
import OurServiceImg2 from "../../../assets/ourserviceimg2.svg";
import OurServiceImg3 from "../../../assets/ourserviceimg3.svg";
import OurServiceImg4 from "../../../assets/ourserviceimg4.svg";
import OurServiceImg5 from "../../../assets/ourserviceimg5.svg";
import OurServiceImg6 from "../../../assets/ourserviceimg6.svg";
import { useTranslation } from "react-i18next";

import { OurServicesListItems } from "./ourserviceslistitems.component";

const OurServicesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 48px;
  padding-bottom: 100px;

  @media (max-width: 480px) {
  max-width: 480px; 
  }
`;
const OurServicesContainer = styled.div.attrs({
  id: "services",
})`
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const OurServicesHeading = styled.p`
  font-weight: 700;
  font-size: 40px;
  color: rgba(29, 109, 193, 1);
  padding-top: 64px;
  @media (max-width: 480px) {
    text-align: center;
  }
`;
const OurServicesPara = styled.p`
  font-weight: 400;
  font-size: 18px;
  padding-top: 12px;
  @media (max-width: 480px) {
    text-align: center;
    font-size: 12px;
  }
`;

export const OurServices = () => {
  const { t } = useTranslation();
  return (
    <OurServicesContainer>
      <OurServicesHeading>{t('our-services-heading')}</OurServicesHeading>
      <OurServicesPara>
        {t('our-services-para')}
      </OurServicesPara>
      <OurServicesList>
        <OurServicesListItems
          img={OurServiceImg1}
          heading={t('our-services-1-heading')}
          para={
          t('our-services-1-para')  
          }
        />
        <OurServicesListItems
          img={OurServiceImg2}
          heading={t('our-services-2-heading')}
          para={
          t('our-services-2-para')  
          }
        />
        <OurServicesListItems
          img={OurServiceImg3}
          heading={t('our-services-3-heading')}
          para={
          t('our-services-3-para')  
          }
        />
        <OurServicesListItems
          img={OurServiceImg4}
          heading={t('our-services-4-heading')}
          para={
          t('our-services-4-para')  
          }
        />
        <OurServicesListItems
          img={OurServiceImg5}
          heading={t('our-services-5-heading')}
          para={
          t('our-services-5-para')   
          }
        />
        <OurServicesListItems
          img={OurServiceImg6}
          heading={t('our-services-6-heading')}
          para={
          t('our-services-6-para')     
          }
        />
      </OurServicesList>
    </OurServicesContainer>
  );
};
